import Paragraph from "@common/components/Paragraph/Paragraph";
import Tag from "@common/components/Tag/Tag";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1.4rem 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${vars.colors.grey90};
  }

  &:hover {
    .members-row-actions {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const Avatar = styled.img`
  width: 4rem;
  height: 4rem;
`;

export const MemberDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.1rem;
`;

export const AiName = styled(Paragraph)`
  background-image: linear-gradient(108.43deg, #d1d1d6 35%, #6d6d70 71.25%);
  color: transparent;
  background-clip: text;
`;

export const Name = styled(Paragraph)`
  color: ${vars.colors.grey30};
`;

export const Email = styled(Paragraph)`
  padding-right: 3rem;
  color: ${vars.colors.grey60};
`;

export const RowTag = styled(Tag)`
  height: 2.4rem;
  color: ${vars.colors.grey60};
`;

export const ActionsWrap = styled.div`
  display: flex;
  flex-direction: row;
  background: #3a3a3c;
  border: 1px solid #48484a;
  border-radius: 1rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  padding: 0.3rem;
`;

export const ActionButton = styled.button`
  outline: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 0.8rem;

  &:hover {
    background: ${vars.colors.grey80};
  }
`;
